export default __webpack_public_path__ + "static/media/icon-new-note.5c720bbe.svg";